module.exports = __webpack_public_path__ + "static/img/empty.eb4c555.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty.png
// module id = 206
// module chunks = 20